"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdNumberValidator = void 0;
var class_validator_1 = require("class-validator");
var IdNumberValidator = exports.IdNumberValidator = /** @class */ (function () {
    function IdNumberValidator() {
    }
    IdNumberValidator.prototype.validateNumbers = function (numbers) {
        var verifier = 11;
        var sum = numbers.reduce(function (acc, num, i) {
            if (i === numbers.length - 1) {
                return acc;
            }
            var weight = (numbers.length - i);
            return acc + (num * weight);
        }, 0);
        var factor = sum % verifier;
        var reference = (factor < 2) ? 0 : (verifier - factor);
        return reference === numbers[numbers.length - 1];
    };
    IdNumberValidator.prototype.validate = function (idNumber) {
        var regex = /^\d{9}-\d{2}$/;
        if (!regex.test(idNumber)) {
            return false;
        }
        var idDigits = idNumber.replace(/\D/g, '').split('').map(function (x) { return parseInt(x, 10); });
        return this.validateNumbers(idDigits.slice(0, idDigits.length - 1)) && this.validateNumbers(idDigits);
    };
    IdNumberValidator.prototype.defaultMessage = function () {
        return '$property must be a valid brazilian CPF using the format 123456789-12';
    };
    IdNumberValidator = __decorate([
        (0, class_validator_1.ValidatorConstraint)({ name: 'idNumber', async: false })
    ], IdNumberValidator);
    return IdNumberValidator;
}());
